
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.035 3h-2.5v-.5a1.5 1.5 0 00-1.5-1.5h-3a1.5 1.5 0 00-1.5 1.5V3h-2.5a.5.5 0 000 1h.5v9a1 1 0 001 1h8a1 1 0 001-1V4h.5a.5.5 0 000-1zm-7.5-.5a.5.5 0 01.5-.5h3a.5.5 0 01.5.5V3h-4v-.5zm6 10.5h-8V4h8v9zm-5-6.5v4a.5.5 0 01-1 0v-4a.5.5 0 111 0zm3 0v4a.5.5 0 01-1 0v-4a.5.5 0 111 0z","fill":"#EB3131"}})])
          )
        }
      }
    